export interface WizardGuarantor {
  id: string;
  name: string;
  type: "contact" | "account";
  contactId?: string;
  accountId?: string;
}

export interface UnlinkedGuarantor {
  id: string;
  partyName: string;
  contactId?: string | null;
  accountId?: string | null;
}

export interface GuarantorFormData {
  guarantorId: string;
  guaranteeType: string;
  liabilityType: string;
  limitedAmount: string;
  included: boolean;
}

export function mapUnlinkedGuarantorsToWizardGuarantors(
  guarantors: UnlinkedGuarantor[],
): WizardGuarantor[] {
  return guarantors.map((guarantor) => ({
    id: guarantor.id,
    name: guarantor.partyName,
    type: guarantor.accountId ? "account" : "contact",
    contactId: guarantor.contactId ?? undefined,
    accountId: guarantor.accountId ?? undefined,
  }));
}

export function buildUnlinkedGuarantorWarning(guarantors: UnlinkedGuarantor[]) {
  if (guarantors.length === 1) {
    return {
      title: "Guarantor Warning",
      description: `Guarantor ${guarantors[0].partyName} has no linked guarantee security. Please add a guarantee for this party.`,
    };
  }

  const names = guarantors.map((guarantor) => guarantor.partyName).join(", ");

  return {
    title: "Guarantor Warning",
    description: `${guarantors.length} guarantors have no linked guarantee security: ${names}. Please add guarantees for these parties.`,
  };
}

export function buildInitialGuarantorFormData(
  guarantors: WizardGuarantor[],
): Record<string, GuarantorFormData> {
  return guarantors.reduce<Record<string, GuarantorFormData>>((acc, guarantor) => {
    const guaranteeType =
      guarantor.type === "account" ? "corporate" : "personal_unlimited";

    acc[guarantor.id] = {
      guarantorId: guarantor.id,
      guaranteeType,
      liabilityType:
        guaranteeType.includes("unlimited") || guaranteeType === "corporate"
          ? "unlimited"
          : "limited_amount",
      limitedAmount: "",
      included: true,
    };

    return acc;
  }, {});
}
